import React, { Component } from "react";
import translator from "../../../components/localization/translator";

export default class TextareaWithLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
        }
    }

    renderLabel() {
        if (!this.props.label) {
            return null;
        }
        return (
            <label htmlFor={this.props.htmlFor}
                   className={"label-width"}>{translator.translate(this.props.label)}</label>
        );
    }

    render() {
        let additionalStyle = this.props.additionalStyle || "";
        if (this.props.style) {
            additionalStyle = `${additionalStyle} padding`;
        }

        let customStyle = this.props.customStyle ? this.props.customStyle : "my-custom-input",
            customWidth = this.props.customWidth ? this.props.customWidth : "";

        return (
            <div className={`display-flex ${additionalStyle} ${customWidth}`}>
                {this.renderLabel()}
                <textarea
                    type="text"
                    rows="3"
                    id={this.props.id}
                    disabled={this.props.disabled}
                    value={this.state.value}
                    onChange={(e) => {
                        const value = e.target.value;
                        this.setState({ value });
                        this.props.onChange(e);
                    }}
                    className={`form-control default-font ${customStyle}`} />
            </div>
        );
    }
}
